import { render, staticRenderFns } from "./InvoicesReceived.vue?vue&type=template&id=361776e0&scoped=true"
import script from "./InvoicesReceived.vue?vue&type=script&lang=js"
export * from "./InvoicesReceived.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361776e0",
  null
  
)

export default component.exports